export const SET_PERMISSIONS = "SET_PERMISSIONS";

export function setPermissions(payload){
    return {type: SET_PERMISSIONS, payload};
};